<app-side-nav class="w-screen h-screen"></app-side-nav>
<div appToaster appDialogContainer></div>
